module.exports = __webpack_public_path__ + "media/start.c5c1ee84.mp3";